/* eslint no-redeclare: "off" */
/* eslint no-unused-vars: "off" */

import _ from 'lodash';

export function heightDelegate(events) {
  //縦幅を変えるイベントを登録
  var catchEvents;
  var delegate;

  //デフォルト値
  var events = [
    '#accordion-toggle',
    '.message .btn-message-close',
    '.sys-search-form-accordion-trigger',
  ];
}

heightDelegate.prototype = {
  initEvent(events) {
    var _this = this;
    this.delegate = [];
    this.catchEvents = events ? _.union(events, this.events) : this.events;
    _.each(this.catchEvents, function(selector) {
      if (document.querySelector(selector)) {
        document.querySelector(selector).addEventListener('click', function(e) {
          setTimeout(function() {
            _this.emit(e);
          }, 1);
        });
      }
    });

    window.addEventListener('load', function(e) {
      _this.emit(e);
    });

    window.addEventListener('resize', function(e) {
      _this.emit(e);
    });

    window.visualViewport.addEventListener('resize', function(e) {
      _this.emit(e);
    });
  },

  addElement(elem) {
    this.events.push(elem);
  },

  forceUpdate() {
    this.emit();
  },

  setDelegate(func) {
    this.delegate.push(func);
  },

  emit(e) {
    _.each(this.delegate, function(func) {
      func(e);
    });
  },
};



// WEBPACK FOOTER //
// ./src/utilities/heightDelegate.js